@use "~theme/typography";
@use "~theme/breakpoints";

.footer {
    display: flex;
    flex-direction: column;
    padding: 30px 20%;
    background: var(--gray-03);
    border-top: 1px solid var(--gray-06);
  
    @include breakpoints.desktop {
      flex-direction: row;
      padding-top: 44px;
      padding-left: 0;
      padding-right: 0;
    }
  }
  
  .footerSection {
    flex: 1;
  
    @include breakpoints.desktop {
      padding-top: 12px;
      padding-bottom: 12px;
    }
  }
  
  .footerLeft {
    @include breakpoints.desktop {
      margin-left: 20%;
    }
  }
  
  .footerRight {
    @include breakpoints.desktop {
      margin-right: 20%;
    }
  }
  
  .footerDivider {
    margin: 28px 0;
    height: 1px;
    border: 0;
    background-color: var(--blue-01-at-30);
  
    @include breakpoints.desktop {
      flex-shrink: 0;
      height: auto;
      width: 1px;
      margin: 0 64px;
    }
  }
  
  .footerHeading {
    @include typography.heading4;
    text-align: center;
    margin: 0;
  
    @include breakpoints.desktop {
      padding-bottom: 8px;
    }
  }
  
  .footerHeadingWithTooltip {
    display: flex;
    justify-content: center;
  
    > :first-child {
      margin-right: 8px;
    }
  }
  
  .footerParagraph {
    text-align: center;
    margin: 8px 0 0;
  
    @include breakpoints.desktop {
      padding: 0px;
      margin:0px;
    }
  }
  
  .footerPhoneLink {
    white-space: nowrap;
  }
  
  .footerLinkContainer {
    text-align: center;
    margin: 32px 0;
  
    @include breakpoints.desktop {
      margin: 16px 0;
    }
  }
  
  .footerLink {
    color: var(--black);
    text-transform: uppercase;
  }
  
  .footerNextBtn {
    margin: 0px 0px 30px 0px;
  }

  .smsFooter {
    padding: 0px 20% 20px 20%;
    background: var(--gray-03);
    text-align: center;
    margin-top: -16px;
    font-size: 12px;
    line-height: 140%;
  }